import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer
} from "../../../common/AbstractListView";
import lockRed from '../../../../img/lock_red.png';
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  CurrencyAmountRenderer, DateRenderer, DateTimeRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../../uiControls/CurrencyLabel';
import SmartTable from '../../../../uiControls/SmartTable';
import {JobNames} from "../../../../framework.core/JobNames";
import {ccPaymentList} from "../../tableSettings";
import UniqueLinkButton from "../../../../uiControls/UniqueLinkButton";
import {CreditPaymentListItem} from "../../../../fms.data/models/CreditPaymentListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import IfmsModal from '../../../../ui/IfmsModal';
import HistoryViewPayment from '../../../reports/HistoryViewPayment';
import DeleteHistoryPaymentView from '../../../reports/DeleteHistoryPaymentView';
import { FmsSubMenu } from '../../../../constants/fmsSubMenu';
import { FmsSecTask } from '../../../../fms.core/constants';
import { findSecurityTask, getSecBySecTask } from '../../../../util';
import { useJournal } from '../../general/journal/JournalListView';
import useSuntekSettings from '../../../../hooks/useSuntekSettings';
import { nowDate } from '../../../../dateUtils';
import VendorBalanceDetails from '../../../reports/AccountBalance';
import { SecType } from '../../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../../common/commonExportFormat';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as CreditPaymentListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acCCPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }
    // New Mode와 Edit Mode를 동시에 열 수 없도록 수정
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acCCPayment/edit')) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }

    openNewPage(history, '/accounting/acCCPayment/add', NavigationType.newPage);
  }


  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/accounting/acCCPayment/edit/${id}`;
    const viewUrl = `/accounting/acCCPayment/view/${id}`;
    if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/accounting/acCCPayment/edit', editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    // New Mode와 Edit Mode를 동시에 열 수 없도록 수정
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acCCPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/accounting/acCCPayment/edit/${id}`;
    const viewUrl = `/accounting/acCCPayment/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctCCPayment);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acCCPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/accounting/acCCPayment/add?copyId=${id}`, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.CCPayment}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return {create, edit, view, copy, moveToDeleteHistoryReport};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctCCPayment);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: true, hidden: !listSec?.grantEdit },
    //{ label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },    //240912.dwshin. delete button remove
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: false, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="ccPayment-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      // case 3:
      //   edit();
      //   break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      case 4:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as CreditPaymentListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalPayment && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.CCPayment, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as CreditPaymentListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctCCPayment);
  const readSecDelHistory = getSecBySecTask(appContext, FmsSecTask.AcctCCPayDeleteHistory, SecType.Read);
  
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const {edit, view, moveToDeleteHistoryReport} = useSelectedOperations();

  // function hasOpenedViewOrEditFor(id: number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acCCPayment/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acCCPayment/view/${id}`);
  // }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function vendorBalance() {
    if (selectedElement.vendorId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Vendor.</p>, false, null, 'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <VendorBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.BillPayment}
          onPopupClose={onPopupClose}
          toDate={nowDate()}
          comId={selectedElement.vendorId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.vendor}
        />
    })
  }

  // function hasOpenedNew() {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acCCPayment/add`);
  // }

  const hasSelectedRow = !!selectedElement;
  //240912.dwshin. delete button remove>
  //const canBeDeleted = hasSelectedRow && !hasOpenedViewOrEditFor(selectedElement.id) && listSec?.grantDel && !selectedElement.depositDate;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='ccPayment-list-add-button' display="primary" size="regular" link="/accounting/acCCPayment/add" disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='ccPayment-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='ccPayment-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        {/* <PrimaryButton name='ccPayment-list-delete-button' size="regular" disabled={!canBeEdit || !canBeDeleted} onClick={edit}>Delete</PrimaryButton> */}
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton name='ccPayment-list-history-button' size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1240, popupComponent: <HistoryViewPayment jobId={selectedElement.id} jobType={FmsSubMenu.MPHistory} /> })}>View History</PrimaryButton>&nbsp;
        { readSecDelHistory && <><PrimaryButton name='ccPayment-list-deleteHistory-button' size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>&nbsp;</> }
        <PrimaryButton name='ccPayment-list-balance-button' size="regular" disabled={!hasSelectedRow} onClick={vendorBalance}>Balance</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctCCPayment);
  const history = useHistory();

  const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  function onLinkToAccounting(entity: any) {
    if (!entity || !entity.category || !entity.number) {
      return;
    }

    if (entity.category === 'Bill') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/bill/accounting', 'billNo', 'Bill #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/bill/accounting`, NavigationType.newPage);
    }
    if (entity.category === 'Invoice') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/accounting', 'invoiceNo', 'Invoice #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/invoice/accounting`, NavigationType.newPage);
    }
    if (entity.category === 'CrDb') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/accounting', 'crdbNo', 'CrDb #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/crdb/accounting`, NavigationType.newPage);
    }
  }

  async function loadInfoAreaInvoiceBillCrDb(id: string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions: ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      
      rowRenderers: [
        {accessor: 'date', Cell: TextRenderer},
        {accessor: 'category', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
        {accessor: 'companyName', Cell: TextAlignLeftRenderer},
        {accessor: 'cur', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
      ],
    };

    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.CCPayment}
      //entityId={(jobListContext.selectedElement as CreditPaymentListItem | null)?.id}
      jobId={(jobListContext.selectedElement as CreditPaymentListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Customer Payment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.CCPayment,
      'CreditPaymentListItem',
      CreditPaymentListItem.calculateSearchParameters(search, CreditPaymentListItem.MapSearchFields),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: CreditPaymentListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      // {accessor: 'void', Cell: NullableCheckboxIconRenderer, Header: () => <div data-tooltip="Void">V</div>},
      {accessor: 'block', Cell: NullableCheckboxIconRenderer},
      {accessor: 'vendor', Cell: TextAlignLeftRenderer},
      {accessor: 'acctSName', Cell: TextAlignLeftRenderer},
      {accessor: 'ccRefNo', Cell: TextAlignLeftRenderer},
      {accessor: 'checkNo', Cell: TextAlignLeftRenderer},
      {accessor: 'bankName', Cell: TextAlignLeftRenderer},
      {accessor: 'currency', Cell: TextRenderer},
      {accessor: 'totalAmt', Cell: props => <CurrencyAmountRenderer currencyAccessor={(x:any) => x.currency} {...props} />},
      {accessor: 'invoiceNo', Cell: TextAlignLeftRenderer},
      {accessor: 'remark', Cell: TextAlignLeftRenderer},
      {accessor: 'postDate', Cell: DateRenderer},
      {accessor: 'depositDate', Cell: DateRenderer},
      // {accessor: 'voidDate', Cell: DateRenderer},
      {accessor: 'u1Date', Cell: DateTimeRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
      {accessor: 'u2ID', Cell: TextAlignLeftRenderer},
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'block', changedValue: (value: any) => { return nullableCheckBoxValue(value['block'])} });
    colRenderer.push({ accessor: 'totalAmt', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['totalAmt']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  ccPaymentList;
    const cols = CreditPaymentListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }


  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: CreditPaymentListItem) {
    return row && row.id ? `/accounting/acCCPayment/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'CC Pay List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.CCPayment} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
